import React from 'react';
import { CustomForm } from './styles';
export default function ModalForm({
  children
}) {
  return <CustomForm data-testid="doc-form">{children}</CustomForm>;
}